<template>
    <component
        v-bind:is="tag"
        v-bind:key="key"
        v-bind:class="classObject"
        v-bind:data-bs-toggle="dropdownDataToggle"
        style="line-height: 1; --bs-btn-box-shadow: 0 0 transparent"
        v-on:focusin="onFocusin"
        v-on:focusout="onFocusout"
        v-on:click="click">
        <pc-bs-icon
            v-bind:name="iconName"
            style="font-size: 1.5rem" />
        <div
            ref="tooltipDiv"
            v-tooltip="tooltip"
            v-bind:class="tooltipClassObject"
            style="top: 0; right: 0"></div>
    </component>
</template>

<script>
    import { Tooltip } from "bootstrap";
    import { IS_DEBUG_BUILD } from "Util/util";

    export default {
        directives: {
            tooltip: {
                /**
                 * @param {HTMLElement} el
                 */
                beforeMount(el, binding) {
                    const tooltip = binding.value;
                    if (tooltip) {
                        const options = {
                            title: tooltip,
                            placement: "bottom"
                        };
                        new Tooltip(el, options);
                    }
                },
                unmounted(el) {
                    const instance = Tooltip.getInstance(el);
                    if (instance) {
                        instance.dispose();
                    }
                }
            }
        },
        props: {
            iconName: { type: String, required: true },
            tooltip: { type: String, required: false, default: null },
            tag: { type: String, required: false, default: "button" },
            invert: { type: Boolean, required: false, default: false },
            dropdown: { type: Boolean, required: false, default: false }
        },
        emits: ["click"],
        computed: {
            key() {
                let key = `${this.iconName}_${this.tooltip}`;
                key = key.replace(/\s/g, "");
                return key;
            },
            classObject() {
                return {
                    btn: true,
                    "position-relative": true,
                    "border-0": true,
                    "p-2": true,
                    "rounded-circle": !this.dropdown,
                    "rounded-pill": this.dropdown,
                    "dropdown-toggle": this.dropdown,
                    "btn-outline-primary": !this.invert,
                    "btn-primary": this.invert,
                    "shadow-none": this.invert
                };
            },
            tooltipClassObject() {
                return {
                    "border-0": true,
                    "position-absolute": true,
                    transparent: true,
                    "h-100": true,
                    "w-100": true,
                    "rounded-circle": !this.dropdown,
                    "rounded-pill": this.dropdown
                };
            },
            dropdownDataToggle() {
                return this.dropdown ? "dropdown" : null;
            }
        },
        mounted() {
            this._dbgWarnMissingLabels();
        },
        methods: {
            onFocusin() {
                Tooltip.getInstance(this.$refs.tooltipDiv)?.show();
            },
            onFocusout() {
                Tooltip.getInstance(this.$refs.tooltipDiv)?.hide();
            },
            click() {
                this.$emit("click");
                setTimeout(() => {
                    this.$el.blur(); // unfocus button so that tooltip is removed.
                }, 0);
            },
            _dbgWarnMissingLabels() {
                if (!IS_DEBUG_BUILD) {
                    return;
                }

                if (!this.tooltip && !this.$attrs["aria-label"]) {
                    this.$app.registerAccessibilityViolation(
                        `header-icon element must have a tooltip or aria-label. iconName:${this.iconName}`
                    );
                }
            }
        }
    };
</script>

<style></style>
